import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Icon,
  Menu,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { AuthService } from "src/services/auth/auth.service";
import "./profile-icon.component.scoped.sass";

export const ProfileIconComponent = (props: any) => {
  const authService: AuthService = new AuthService();
  const empty: any = {data: {}};
  const [user, setUser] = useState(empty);
  const [t] = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    await authService.logout();
  };

  async function getUser() {
    const currentUser = await authService.me();
    setUser(currentUser);
  }

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="profile"
      style={props.layout === "half" ? { display: "none" } : {}}
    >
      <div className="profile-image">
        <img src="/profile.svg" alt="profile img" onClick={handleClick} />
        <Menu
          id="header-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="header-menu"
        >
          <MenuItem className="user-info">
            <div></div>
            <div className="user-name">{user.data.email}</div>
            <div className="user-role">{t('admin')}</div>
          </MenuItem>
          <MenuItem onClick={logout}>
            <Icon>logout</Icon>
            {t("logout")}
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};
